import useIdVerificationStatus from "./useIdVerificationStatus";
import useNeedsAccountVerification from "./useNeedsAccountVerification";
import usePaymentVerificationStatus from "./usePaymentVerificationStatus";
import useUseCaseVerificationStatus from "./useUseCaseVerificationStatus";

export default function useVerificationActionRequired() {
  const { status: useCaseVerificationStatus } = useUseCaseVerificationStatus();
  const { status: paymentVerificationStatus } = usePaymentVerificationStatus();
  const { status: idVerificationStatus } = useIdVerificationStatus();
  const { needsIdVerification } = useNeedsAccountVerification();

  const useCaseVerificationActionRequired =
    useCaseVerificationStatus !== null &&
    useCaseVerificationStatus !== "in-review";

  const idVerificationActionRequired =
    Boolean(needsIdVerification) &&
    idVerificationStatus !== null &&
    ["required", "failed"].includes(idVerificationStatus);

  const paymentVerificationActionRequired =
    paymentVerificationStatus !== null &&
    paymentVerificationStatus !== "in-review";

  const actionRequired =
    useCaseVerificationActionRequired ||
    idVerificationActionRequired ||
    paymentVerificationActionRequired;

  return actionRequired;
}
